import { Link } from 'react-aria-components';
import { Trans } from '@lingui/react/macro';

import Logo from '@/design_system/Logo';
import Stack from '@/design_system/Stack';
import Paragraph from '@/design_system/Typography/Paragraph';
import { createBEMClasses } from '@/utils/classname';

import './PoweredBy.css';

const { block } = createBEMClasses('powered-by');

const PoweredBy = () => (
  <Stack row className={block()} gap="0.5rem">
    <Paragraph size="200" color="secondary">
      <Trans id="client.new.footer.powered-by">Powered by</Trans>
    </Paragraph>
    <Link href="https://prolong.io/" target="_blank">
      <Logo />
    </Link>
  </Stack>
);

export default PoweredBy;
